import PdfView from './pdf_view';

const Pdf = PdfView;
export default Pdf;
